export const DEFAULT_PRIVACY = {
  title: "Privacy Policy",
  body: `Keys Event Center ("we", "us") respects your privacy. This policy explains what information we collect through this website and how we use it.

INFORMATION WE COLLECT
- Reservation details: your name, email, phone number, date of birth (to confirm you are 18+), event type, guest count, notes, and your electronic signature on the Reservation Agreement and Liability Waiver.
- Waiver details: participant name, date of birth, parent/guardian name for minors, optional email/phone, and the electronic signature.
- Signing records: the date and time of signing, your IP address and browser/device type, kept as proof of your electronic signature.
- Payment: card payments are processed by Stripe. We never see or store your full card number.
- Basic website usage analytics.

HOW WE USE IT
We use your information to confirm and manage your reservation, keep signed agreements and waivers on file, send confirmation emails, contact you about your booking, and meet legal and insurance obligations.

WHO WE SHARE IT WITH
We do not sell your personal information. We share only what is needed with the service providers that run our booking system: Stripe (payments), Bookeo (scheduling calendar), Resend (email delivery) and Telegram (private booking alerts to our staff). Information may also be disclosed if required by law.

HOW LONG WE KEEP IT
Reservation, agreement and waiver records are kept for as long as needed for business, legal and insurance purposes.

CHILDREN
Waivers for participants under 18 must be completed by a parent or legal guardian. Reservations may only be made by adults 18 or older.

YOUR CHOICES
You may contact us to ask what information we hold about you or to request a correction or deletion, subject to records we must keep for legal or insurance reasons.

CONTACT
Questions? Email us at {email}.`,
};

export const DEFAULT_REFUND = {
  title: "Cancellations & Refunds",
  body: "Please contact us at least 48 hours in advance to reschedule. For questions about cancellations or refunds, email us at {email}.",
};

export const ESIGN_CONSENT_TEXT =
  "I agree to sign this document electronically and to receive copies of it and related records electronically. I understand my electronic signature has the same legal effect as a handwritten signature, and I may request a paper copy by contacting Keys Event Center.";

export const fillEmail = (text, email) => (text || "").replaceAll("{email}", email || "keyseventcenter@gmail.com");
